import createIcon from '../../createIcon';

/**
 * @component @name Beenhere
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgMUg1QzMuOSAxIDMuMDEgMS45IDMuMDEgM0wzIDE1LjkzQzMgMTYuNjIgMy4zNSAxNy4yMyAzLjg4IDE3LjU5TDEyIDIzTDIwLjExIDE3LjU5QzIwLjY0IDE3LjIzIDIwLjk5IDE2LjYyIDIwLjk5IDE1LjkzTDIxIDNDMjEgMS45IDIwLjEgMSAxOSAxWk0xMCAxNkw1IDExTDYuNDEgOS41OUwxMCAxMy4xN0wxNy41OSA1LjU4TDE5IDdMMTAgMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Beenhere = createIcon('Beenhere', [
  [
    'path',
    {
      d: 'M19 1H5C3.9 1 3.01 1.9 3.01 3L3 15.93C3 16.62 3.35 17.23 3.88 17.59L12 23L20.11 17.59C20.64 17.23 20.99 16.62 20.99 15.93L21 3C21 1.9 20.1 1 19 1ZM10 16L5 11L6.41 9.59L10 13.17L17.59 5.58L19 7L10 16Z',
      key: '1fecwy',
    },
  ],
]);

export default Beenhere;
